import React from 'react'
import Zoom from '../common/zoom'


function ZoomA(props) {
  return (
    <Zoom
      {...props}
      poster="https://volverse-negro-daniel.s3.amazonaws.com/stills/zoom-1.jpg"
      src="https://volverse-negro-daniel.s3.amazonaws.com/videos/zoom-1.mp4"
    />
  )
}


export default ZoomA
